import * as Configuration from "../config/Configuration";
import * as Constants from "../config/AppConstants";

export const trace = (function() {
  if (!window.console || !console.log) {
    return;
  }
  if (Configuration.logLevels.includes(Constants.LogLevel.SEVERE) === false) {
    return function() {};
  }
  return Function.prototype.bind.call(console.trace, console);
})();
export const debug = (function() {
  if (!window.console || !console.log) {
    return;
  }
  if (Configuration.logLevels.includes(Constants.LogLevel.SEVERE) === false) {
    return function() {};
  }
  return Function.prototype.bind.call(console.debug, console);
})();

export const warn = (function() {
  if (!window.console || !console.log) {
    return;
  }
  if (Configuration.logLevels.includes(Constants.LogLevel.WARNING) === false) {
    return function() {};
  }
  return Function.prototype.bind.call(console.warn, console);
})();

export const error = (function() {
  if (!window.console || !console.log) {
    return;
  }
  if (Configuration.logLevels.includes(Constants.LogLevel.ERROR) === false) {
    return function() {};
  }
  return Function.prototype.bind.call(console.error, console);
})();

export const info = (function() {
  if (!window.console || !console.log) {
    return;
  }
  if (Configuration.logLevels.includes(Constants.LogLevel.STANDARD) === false) {
    return function() {};
  }
  return Function.prototype.bind.call(console.info, console);
})();



// WEBPACK FOOTER //
// ./src/common/Feedback/Log.js